<template>
    <div class="component-chapter-box" @click="validatePaid('/' + $route.params.lang + '/course/' + fields.moduleNumber + '/' + fields.chapterNumber)">
        <div class="picture">
            <img :src="require('@/assets/module-' + fields.moduleNumber + '/chapter/' + $route.params.lang + '/chapter-' + fields.chapterNumber + '-thumb.jpg')" :alt="fields.chapterTitle" :title="fields.chapterTitle" />
            <img :src="require('@/assets/icon-player.png')" :alt="fields.chapterTitle" :title="fields.chapterTitle" class="player" />
            <div class="status" v-if="fields.status">
                <font-awesome-icon :icon="['fas', 'check']" /> DONE
            </div>
        </div>
        <div class="desc">
            <h2>{{ fields.chapterTitle }}</h2>
        </div>
    </div>
</template>

<script>
import ValidateChapter from '@/resources/ValidateChapter';

export default {
    mixins: [ValidateChapter],
    props: {
        fields: Object
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.component-chapter-box {
    margin-bottom: 20px;
    background: #fff;
    cursor: pointer;

    &:hover {
        @include boxShadow(0 0 5px rgba(100, 100, 100, 0.2));
        @include transformObject(scale(1.03));
        text-decoration: none;
    }

    .picture {
        position: relative;
        display: block;

        img {
            display: block;
            width: 100%;
        }

        .player {
            position: absolute;
            z-index: 0;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }

        .status {
            position: absolute;
            z-index: 1;
            right: 0;
            bottom: 10px;
            padding: 5px 10px;
            color: #fff;
            background: rgba(45, 173, 132, 0.8);
        }
    }

    .desc {
        padding: 15px;
        border-bottom: 1px solid #e6dbdb;

        h2 {
            font-size: 13px;
            line-height: 22px;
            margin: 0;
            color: #333;
        }
    }
}
</style>